import { AgentName } from '@/constant/agents';

/**
 * The most characters an agent accepts in one message. The composer counts
 * the composed text (chip bodies plus free text) and blocks a send over it.
 * Agents without an entry have no limit in the composer.
 */
export const AGENT_MESSAGE_LIMITS: Partial<Record<AgentName, number>> = {
  [AgentName.CONNIE]: 5_000,
};

export const getAgentMessageLimit = (agentName?: string) =>
  agentName ? AGENT_MESSAGE_LIMITS[agentName as AgentName] : undefined;
